export const reduxKey = '@@ADS';
export const actionKey = '@@ADS';
// The minimum time between ads refresh on page url change
export const adsRefreshTimeout = 30000;
// The max number of times ads can refresh per session
export const maxAdsRefresh = 60;
